import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/topics", label: "爆料追踪" },
  { to: "/method", label: "真假辨析" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : "/topics");
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `font-label text-sm transition-colors cursor-pointer whitespace-nowrap ${
      isActive ? "text-primary-700" : "text-foreground-700 hover:text-primary-700"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-300 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center gap-6 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
            <i className="ri-radar-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              蝌蚪爆料
            </span>
            <span className="font-label text-[10px] text-foreground-500">证据链 · 可信度追踪</span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-7 lg:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden items-center md:flex" role="search">
          <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 focus-within:border-primary-400">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="搜索事件、关键词"
              aria-label="搜索事件"
              className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 lg:w-52"
            />
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-300 bg-background-50 lg:hidden">
          <div className="mx-auto w-full max-w-[1280px] px-4 py-4 md:px-6">
            <form onSubmit={handleSearch} className="mb-4 md:hidden" role="search">
              <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2.5">
                <i className="ri-search-line text-sm text-foreground-500" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  type="search"
                  placeholder="搜索事件、关键词"
                  aria-label="搜索事件"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>
            </form>
            <nav aria-label="移动端导航" className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `border-b border-background-200 py-3 font-label text-sm last:border-b-0 ${
                      isActive ? "text-primary-700" : "text-foreground-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}